export default {
    listLoading: false,
    documentComments: [],
    sectionComments: []
}
